module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.703cf8f.woff2";